import React from 'react';

import ScreenError from './screen/screen-error';

type State = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<any, State> {
  state: State = {
    hasError: false,
  };

  componentDidCatch(error: Error, info: any) {
    this.setState({ hasError: true });
    console.error(error);
    window.newrelic && window.newrelic.noticeError(error, { extra: { info } });
  }

  render() {
    return this.state.hasError ? (
      <ScreenError headline="Uh oh! Something went wrong." errorName="error" />
    ) : (
      this.props.children
    );
  }
}

export default ErrorBoundary;
